import React from "react";
import { connect } from 'react-redux';

import WarehouseForm from "./WarehouseForm";
import * as Yup from "yup";
import * as actions from './store/warehouseActions';
import History from "../../../History";
import { hasPermission } from "../../sc-utilities";

const WarehouseCreate = props => {
    const { loading, activeCustomer, translations, permissions, onCreateWarehouse } = props;

    const handleSubmit = async data => {
        let requestData = { ...data, ActiveCustomerID: activeCustomer }
        let result = await onCreateWarehouse(requestData);
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: "",
        Description: "",
        Location: "",
        ContactPerson: ""
    };
    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Description: Yup.string(),
            Location: Yup.string().required("Required"),
            ContactPerson: Yup.string().required("Required")
        },
        FormTitle: translations["create_warehouse"] || "Create warehouse",
        ButtonSubmit: hasPermission(permissions, 'warehouse_create') ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return <WarehouseForm
        formSettings={formSettings}
        initialValues={initialValues}
        handleSubmit={handleSubmit}
        loading={loading}
        translations={translations}
    />
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        loading: state.warehouses.warehouse.creating,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateWarehouse: data => dispatch(actions.createWarehouse(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WarehouseCreate);

/**
 *  Translations
 *      create_warehouse
 */